import { formatDateBR } from '../dates.js';
/** Emoji do status de validade — o que salta aos olhos na conversa. */
function selo(item) {
    if (item.expiryStatus === 'expired')
        return '❌';
    if (item.expiryStatus === 'warning')
        return '⚠️';
    return '';
}
function validade(item) {
    if (!item.expiresAt)
        return '';
    const data = `${item.expiryEstimated ? '~' : ''}${formatDateBR(item.expiresAt)}`;
    if (item.expiryStatus === 'expired')
        return `venceu ${data}`;
    return `vence ${data}`;
}
/** Quantidade sem casas decimais inuteis: "2 un", "1,5 kg". */
export function formatQuantity(quantity, unit) {
    const numero = Number.isInteger(quantity)
        ? String(quantity)
        : String(Math.round(quantity * 1000) / 1000).replace('.', ',');
    return `${numero} ${unit}`;
}
/**
 * Ordem dentro da dispensa: o que vence antes vem primeiro (e o que interessa
 * a quem le), e o que nao tem validade fecha a lista, em ordem alfabetica.
 */
function ordenar(items) {
    return [...items].sort((a, b) => {
        if (a.expiresAt && b.expiresAt) {
            if (a.expiresAt !== b.expiresAt)
                return a.expiresAt < b.expiresAt ? -1 : 1;
        }
        else if (a.expiresAt) {
            return -1;
        }
        else if (b.expiresAt) {
            return 1;
        }
        return a.product.name.localeCompare(b.product.name, 'pt-BR');
    });
}
/** Uma linha de item: quantidade, nome, marca e validade. */
export function inventoryItemLine(item, bullet = '•') {
    const partes = [`${formatQuantity(item.quantity, item.product.unit)} — ${item.product.name}`];
    if (item.product.brand && !item.product.name.includes(item.product.brand)) {
        partes.push(item.product.brand);
    }
    const vence = validade(item);
    if (vence)
        partes.push(vence);
    const marca = selo(item);
    return `${bullet} ${partes.join(' · ')}${marca ? ` ${marca}` : ''}`;
}
/**
 * Estoque inteiro em uma mensagem so: uma secao por dispensa, itens dentro e um
 * resumo no fim.
 */
export function buildInventoryText(storages, items, options = {}) {
    const { now = new Date(), bullet = '•', includeEmpty = true, title = 'Almox — estoque' } = options;
    const linhas = [`*${title}* (${formatDateBR(now)})`];
    let totalItens = 0;
    let dispensasComItem = 0;
    for (const storage of storages) {
        const doLocal = ordenar(items.filter((item) => item.storageId === storage.id));
        if (doLocal.length === 0 && !includeEmpty)
            continue;
        const cabecalho = `*${storage.emoji ? `${storage.emoji} ` : ''}${storage.name}*`;
        linhas.push('', doLocal.length === 0 ? `${cabecalho} — vazia` : cabecalho);
        for (const item of doLocal)
            linhas.push(inventoryItemLine(item, bullet));
        totalItens += doLocal.length;
        if (doLocal.length > 0)
            dispensasComItem += 1;
    }
    // Itens cuja dispensa saiu da lista (apagada no meio do caminho) nao podem
    // sumir da mensagem: melhor um bloco "outros" do que estoque invisivel.
    const conhecidas = new Set(storages.map((storage) => storage.id));
    const orfaos = ordenar(items.filter((item) => !conhecidas.has(item.storageId)));
    if (orfaos.length > 0) {
        linhas.push('', '*Sem dispensa*');
        for (const item of orfaos)
            linhas.push(inventoryItemLine(item, bullet));
        totalItens += orfaos.length;
        dispensasComItem += 1;
    }
    linhas.push('', `${totalItens} ${totalItens === 1 ? 'item' : 'itens'} em ${dispensasComItem} ${dispensasComItem === 1 ? 'dispensa' : 'dispensas'}.`);
    return linhas.join('\n');
}
/** Texto de uma dispensa so — mesma formatacao, para compartilhar em separado. */
export function buildStorageText(storage, items, options = {}) {
    return buildInventoryText([storage], items, {
        ...options,
        title: options.title ?? `Almox — ${storage.name}`,
    });
}
//# sourceMappingURL=inventory-text.js.map